<template>
    <div class="page dictionaryPage">

        <el-tabs type="border-card" @tab-click="handleClick" class="asset-room">

            <div class="page-operate">
                <el-button-group>
                    <el-tooltip class="item" effect="dark" :content="$t('c.add')" placement="top-start" :hide-after="1000">
                        <el-button type="primary" size="small" @click="handleAdd()">
                            <i class="nucfont inuc-add"></i>
                        </el-button>
                    </el-tooltip>
                </el-button-group>
            </div>

            <el-tab-pane :label="'培训教室'" class="asset-content">

                <data-tables class="form-table"
                        :data="roomTableData"
                        :table-props="tableProps"
                        :page-size="20"
                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" width="50" align="center">
                    </el-table-column>
                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                            align="center" show-overflow-tooltip
                            sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>

            <el-tab-pane :label="'服务项'" class="asset-content">

                <data-tables class="form-table"
                        :data="equipmentTableData"
                        :table-props="tableProps"
                        :page-size="20"
                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" width="50" align="center"></el-table-column>

                    <!-- column title -->
                    <el-table-column v-for="(title,index) in titles" :prop="title.prop" :label="title.label" :key="index+''"
                            align="center" show-overflow-tooltip sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->

                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>

        </el-tabs>

        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogFormVisible"
            width="450px"
            :close-on-click-modal="false"
            :modal-append-to-body="false">
            <el-form
                :model="dialogForm"
                :rules="formRules"
                class="dialogForm"
                ref="dialogForm"
                @submit.native.prevent
                label-width="100px">
                <el-form-item :label="$t('c.name')" prop="name">
                    <el-input v-model="dialogForm.name" auto-complete="off" :placeholder="$t('tip.name')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="'容量'" prop="trainingNum" v-if="tabIndex==0">
                    <el-input-number v-model="dialogForm.trainingNum" :precision="0" :min="1" :max="10000" label="培训室容纳座位数"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center;">
                <el-button type="primary" @click="dialogSave('dialogForm')" :loading="saveLoading">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
    import api from '@/api';

    export default {
        data() {
            return {
                dialogTitle: this.$t('c.add'),
                tabIndex: 0,
                roomTableData: [],
                equipmentTableData: [],
                dialogFormVisible: false,
                dialogForm: {
                    id: null,
                    name: '',
                    trainingNum: 1,
                },
                formRules: {
                    name: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}
                    ],
                },
                saveLoading: false,
                tableProps: {
                    border: false,
                    stripe: true,
                },
                titles: [
                    {
                        prop: 'name',
                        label: this.$t('c.name'),
                    }, {
                        prop: 'trainingNum',
                        label: '容量'
                    }, {
                        prop: 'createTime',
                        label: this.$t('c.creationTime')
                    }, {
                        prop: 'modifyTime',
                        label: this.$t('c.modificationTime')
                    },{
                        prop: 'creatorName',
                        label: '创建人'
                    },
                ],
            }
        },
        created() {
            this.query();
        },
        methods: {
            query() {
                if(this.tabIndex==0){
                    api.getRoomQuery().then((res) => {
                    let data = res.package;
                    data.forEach(item => {
                        item.createTime = item.createTime?item.createTime.substring(0, 10):'-';
                        item.modifyTime = item.modifyTime?item.modifyTime.substring(0, 10):'-';
                    });
                    this.roomTableData = data;
                    
                });
                }else{
                    api.getEquipmentQuery().then((res) => {
                    let data = res.package;
                    data.forEach(item => {
                        item.createTime = item.creatorTime?item.creatorTime.substring(0, 10):'-';
                        item.modifyTime = item.modifyTime?item.modifyTime.substring(0, 10):'-';
                    });
                    this.equipmentTableData = data;
                    
                });
                }
                
            },

            handleClick(tab, event) {
                this.tabIndex = tab.index;
                if(this.tabIndex==0){
                    this.titles= [
                    {
                        prop: 'name',
                        label: this.$t('c.name')
                    }, {
                        prop: 'trainingNum',
                        label: '容量'
                    }, {
                        prop: 'createTime',
                        label: this.$t('c.creationTime')
                    }, {
                        prop: 'modifyTime',
                        label: this.$t('c.modificationTime')
                    },{
                        prop: 'creatorName',
                        label: '创建人'
                    }
                ];
                }else{
                     this.titles= [
                    {
                        prop: 'name',
                        label: this.$t('c.name')
                    }, {
                        prop: 'createTime',
                        label: this.$t('c.creationTime')
                    }, {
                        prop: 'modifyTime',
                        label: this.$t('c.modificationTime')
                    },{
                        prop: 'creatorName',
                        label: '创建人'
                    }
                ];
                }
                
                this.query();
            },
            handleAdd(supID,level){
                this.dialogFormVisible = true;
                this.$refs['dialogForm'] && this.$refs['dialogForm'].resetFields();
                this.dialogForm={
                    id: null,
                    name: '',
                    trainingNum: 1,
                };
                this.dialogTitle = this.$t('c.add');

            },

            handleEdit(id) {
                this.dialogTitle = this.$t('c.edit');
                this.dialogFormVisible = true;
                this.$refs['dialogForm'] && this.$refs['dialogForm'].resetFields();
                if(this.tabIndex==0){
                    api.getRoomInfoQuery(id).then((res) => {
                    this.dialogForm.id = res.package.id;
                    this.dialogForm.name = res.package.name;
                    this.dialogForm.trainingNum = res.package.trainingNum;
                });
                }else{
                    api.getEquipmentInfoQuery(id).then((res) => {
                    this.dialogForm.id = res.package.id;
                    this.dialogForm.name = res.package.name;
                });
                }
            },
            handleDelete(id) {
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                     if(this.tabIndex==0){
                    api.trainingRoomDelete(id).then((res) => {
                        this.success(this.$t('m.delSuccess'));
                        this.query();
                    });
                }else{
                     api.trainingRoomDeleteEquipment(id).then((res) => {
                        this.success(this.$t('m.delSuccess'));
                        this.query();
                    });
                }
                   
                }).catch(() => {});
            },
            dialogSave(formName){
                this.$refs[formName].validate((valid) => {
                    if (!valid) return;
                    this.saveLoading = true;
                    if (this.dialogForm.name && this.dialogForm.id) {
                        if(this.tabIndex==0){
                            api.trainingRoomUpSert(this.dialogForm).then((res) => {
                            this.dialogFormVisible = false;
                            this.saveLoading = false;
                            this.success(this.$t('m.editSuccess'));
                            this.query();
                        }).catch(error => this.saveLoading = false);
                        }else{
                            api.trainingRoomEquipmentUpsert(this.dialogForm).then((res) => {
                            this.dialogFormVisible = false;
                            this.saveLoading = false;
                            this.success(this.$t('m.editSuccess'));
                            this.query();
                        }).catch(error => this.saveLoading = false);
                        }
                        
                    } else {
                        if(this.tabIndex==0){
                            api.trainingRoomUpSert(this.dialogForm).then((res) => {
                            this.dialogFormVisible = false;
                            this.saveLoading = false;
                            this.success(this.$t('m.addSuccess'));
                            this.query();
                        }).catch(error => this.saveLoading = false);
                        }else{
                            api.trainingRoomEquipmentUpsert(this.dialogForm).then((res) => {
                            this.dialogFormVisible = false;
                            this.saveLoading = false;
                            this.success(this.$t('m.addSuccess'));
                            this.query();
                        }).catch(error => this.saveLoading = false);
                        }
                        
                    }
                });
            },

            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
        computed: {},
        watch: {},
        components: {}
    }
</script>

<style scoped lang="scss">
 @import '../../style/const.scss';
    .page-operate {
        margin-bottom: 10px;
    }

    .dialogForm {
        margin-right: 40px;
    }
    .asset-room{
        height: 100%;
        /deep/ .el-tabs__content{
            height: 95%;
        }
    }
    .asset-content{
        height: 93%;
    }
    .form-table{
        height: 100%;
        /deep/.el-table{
            height: 100%;
        }
        /deep/.el-table__body-wrapper{
            height: calc(100% - 46px);
           overflow-y: auto;
        }
        // display: flex;
        // flex: 1;
        // flex-direction: column; 
        
    }
</style>

